var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audit-equipment-status-badge"},[(_vm.auditEquipment)?_c('b-badge',{attrs:{"variant":_vm.variant}},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }